// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PersonalOfficeMenu_wrap__3FyyC","menu":"PersonalOfficeMenu_menu__2RHpC","logout":"PersonalOfficeMenu_logout__26-Io"};